/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Editor_New_TitleInputs */

const en_editor_new_title = /** @type {(inputs: Editor_New_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New recipe`)
};

const de_editor_new_title = /** @type {(inputs: Editor_New_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neues Rezept`)
};

/**
* | output |
* | --- |
* | "New recipe" |
*
* @param {Editor_New_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const editor_new_title = /** @type {((inputs?: Editor_New_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Editor_New_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_editor_new_title(inputs)
	return en_editor_new_title(inputs)
});